import React from "react";
import Card from "react-bootstrap/Card";

export const PrivacyPolicy = () => {
    return (
        <>
            <div className="container-fluid mt-4">
                <Card className="mb-4 w-100">
                    <Card.Header as="h2" className="header-card">
                        <span>Privacy Statement</span>
                    </Card.Header>
                    <Card.Body>
                        <Card.Text>
                            Navajo Nation Department of Personnel Management is
                            committed to protecting your privacy and developing
                            technology that gives you the most powerful and safe
                            online experience. This Statement of Privacy applies
                            to the Navajo Nation Department of Personnel
                            Management site and governs data collection and
                            usage. By using the Navajo Nation Department of
                            Personnel Management site, you consent to the data
                            practices described in this statement.
                        </Card.Text>
                        <ul>
                            <li className="card-text bottom-space">
                                <strong>
                                    {" "}
                                    Collection of your Personal Information{" "}
                                </strong>
                                <Card.Text>
                                    Navajo Nation Department of Personnel
                                    Management collects personally identifiable
                                    information, such as your email address,
                                    name, home or work address, or telephone
                                    number. Navajo Nation Department of
                                    Personnel Management also collects anonymous
                                    demographic information, which is not unique
                                    to you, such as your ZIP code, age, gender,
                                    preferences, interests, and favorites. There
                                    is also information about your computer
                                    hardware and software that is automatically
                                    collected by Navajo Nation Department of
                                    Personnel Management. This information can
                                    include: your IP address, browser type,
                                    domain names, access times, and referring
                                    website addresses. This information is used
                                    by Navajo Nation Department of Personnel
                                    Management for the operation of the service,
                                    to maintain quality of the service, and to
                                    provide general statistics regarding use of
                                    the Navajo Nation Department of Personnel
                                    Management site. Navajo Nation Department of
                                    Personnel Management encourages you to
                                    review the privacy statements of Web sites
                                    you choose to link to from Navajo Nation
                                    Department of Personnel Management so that
                                    you can understand how those Web sites
                                    collect, use, and share your information.
                                    Navajo Nation Department of Personnel
                                    Management is not responsible for the
                                    privacy statements or other content on Web
                                    sites outside of the Navajo Nation
                                    Department of Personnel Management and
                                    Navajo Nation Department of Personnel
                                    Management family of Web sites.
                                </Card.Text>
                            </li>
                            <li className="card-text  bottom-space">
                                <strong>
                                    {" "}
                                    Use of your Personal Information
                                </strong>
                                <Card.Text>
                                    Navajo Nation Department of Personnel
                                    Management collects and uses your personal
                                    information to operate the Navajo Nation
                                    Department of Personnel Management Web site
                                    and deliver the services you have requested.
                                    Navajo Nation Department of Personnel
                                    Management also uses your personally
                                    identifiable information to inform you of
                                    other products or services available from
                                    Navajo Nation Department of Personnel
                                    Management and its affiliates. Navajo Nation
                                    Department of Personnel Management may also
                                    contact you via surveys to conduct research
                                    about your opinion of current services or
                                    potential new services that may be offered.
                                    Navajo Nation Department of Personnel
                                    Management does not sell, rent or lease its
                                    customer lists to third parties. Navajo
                                    Nation Department of Personnel Management
                                    may, from time to time, contact you on
                                    behalf of external business partners about a
                                    particular offering that may be of interest
                                    to you. In those cases, your unique
                                    personally identifiable information (e-mail,
                                    name, address, telephone number) is not
                                    transferred to the third party. In addition,
                                    Navajo Nation Department of Personnel
                                    Management may share data with trusted
                                    partners to help us perform statistical
                                    analysis, send you email or postal mail,
                                    provide customer support, or arrange for
                                    deliveries. All such third parties are
                                    prohibited from using your personal
                                    information except to provide these services
                                    to Navajo Nation Department of Personnel
                                    Management, and they are required to
                                    maintain the confidentiality of your
                                    information. Navajo Nation Department of
                                    Personnel Management does not use or
                                    disclose sensitive personal information,
                                    such as race, religion, or political
                                    affiliations, without your explicit consent.
                                    Navajo Nation Department of Personnel
                                    Management keeps track of the Web sites and
                                    pages our customers visit within Navajo
                                    Nation Department of Personnel Management,
                                    in order to determine what Navajo Nation
                                    Department of Personnel Management services
                                    are the most popular. This data is used to
                                    deliver customized content and advertising
                                    within Navajo Nation Department of Personnel
                                    Management to customers whose behavior
                                    indicates that they are interested in a
                                    particular subject area. Navajo Nation
                                    Department of Personnel Management Web sites
                                    will disclose your personal information,
                                    without notice, only if required to do so by
                                    law or in the good faith belief that such
                                    action is necessary to: (a) conform to the
                                    edicts of the law or comply with legal
                                    process served on Navajo Nation Department
                                    of Personnel Management or the site; (b)
                                    protect and defend the rights or property of
                                    Navajo Nation Department of Personnel
                                    Management; or (c) act under exigent
                                    circumstances to protect the personal safety
                                    of users of the Navajo Nation Department of
                                    Personnel Management Web site, or the
                                    public.
                                </Card.Text>
                            </li>
                            <li className="card-text  bottom-space">
                                <strong> Use of Cookies</strong>
                                <Card.Text>
                                    The Navajo Nation Department of Personnel
                                    Management Web site uses &quot;cookies&quot;
                                    to help you personalize your online
                                    experience. A cookie is a text file that is
                                    placed on your hard disk by a Web page
                                    server. Cookies cannot be used to run
                                    programs or deliver viruses to your
                                    computer. Cookies are uniquely assigned to
                                    you, and can only be read by a web server in
                                    the domain that issued the cookie to you.
                                    One of the primary purposes of cookies is to
                                    provide a convenience feature to save you
                                    time. The purpose of a cookie is to tell the
                                    Web server that you have returned to a
                                    specific page. For example, if you
                                    personalize Navajo Nation Department of
                                    Personnel Management pages, or register with
                                    Navajo Nation Department of Personnel
                                    Management site or services, a cookie helps
                                    Navajo Nation Department of Personnel
                                    Management to recall your specific
                                    information on subsequent visits. This
                                    simplifies the process of recording your
                                    personal information, such as billing
                                    addresses, mailing addresses, and so on.
                                    When you return to the same Navajo Nation
                                    Department of Personnel Management Web site,
                                    the information you previously provided can
                                    be retrieved, so you can easily use the
                                    Navajo Nation Department of Personnel
                                    Management features that you customized. You
                                    have the ability to accept or decline
                                    cookies. Most Web browsers automatically
                                    accept cookies, but you can usually modify
                                    your browser setting to decline cookies if
                                    you prefer. If you choose to decline
                                    cookies, you may not be able to fully
                                    experience the interactive features of the
                                    Navajo Nation Department of Personnel
                                    Management services or Web sites you visit.
                                </Card.Text>
                            </li>
                            <li className="card-text  bottom-space">
                                <strong>
                                    {" "}
                                    Security of your Personal Information
                                </strong>
                                <Card.Text>
                                    Navajo Nation Department of Personnel
                                    Management secures your personal information
                                    from unauthorized access, use or disclosure.
                                    Navajo Nation Department of Personnel
                                    Management secures the personally
                                    identifiable information you provide on
                                    computer servers in a controlled, secure
                                    environment, protected from unauthorized
                                    access, use or disclosure. When personal
                                    information (such as a credit card number)
                                    is transmitted to other Web sites, it is
                                    protected through the use of encryption,
                                    such as the Secure Socket Layer (SSL)
                                    protocol.
                                </Card.Text>
                            </li>
                            <li className="card-text  bottom-space">
                                <strong> Changes to this Statement</strong>
                                <Card.Text>
                                    Navajo Nation Department of Personnel
                                    Management will occasionally update this
                                    Statement of Privacy to reflect internal and
                                    customer feedback. Navajo Nation Department
                                    of Personnel Management encourages you to
                                    periodically review this Statement to be
                                    informed of how Navajo Nation Department of
                                    Personnel Management is protecting your
                                    information.
                                </Card.Text>
                            </li>
                            <li className="card-text  bottom-space">
                                <strong> Contact Information</strong>
                                <Card.Text>
                                    Navajo Nation Department of Personnel
                                    Management welcomes your comments regarding
                                    this Statement of Privacy. If you believe
                                    that Navajo Nation Department of Personnel
                                    Management has not adhered to this
                                    Statement, please contact Navajo Nation
                                    Department of Personnel Management at
                                    traci.shortey@dpm.navajo-nsn.gov We will use
                                    reasonable efforts to promptly determine and
                                    remedy the problem.
                                </Card.Text>
                            </li>
                        </ul>
                    </Card.Body>
                </Card>
            </div>
        </>
    );
};
